import { render, staticRenderFns } from "./BOM.vue?vue&type=template&id=1822b699&"
import script from "./BOM.vue?vue&type=script&lang=js&"
export * from "./BOM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports